export const roundToCents = (amount: number): number => {
    return Math.round((amount + Number.EPSILON) * 100) / 100
}

export const formatPriceNumber = (amount: number): string => {
    if (!Number.isFinite(amount)) {
        return '0'
    }

    const rounded = roundToCents(amount)
    const hasFraction = Math.abs(rounded % 1) > Number.EPSILON

    if (!hasFraction) {
        return String(Math.trunc(rounded))
    }

    return rounded.toFixed(2)
}

/**
 * Money in a store's own currency with its plain symbol: "$54", not the "US$54"
 * that en-GB formatting gives every non-pound dollar. Each store has one
 * currency, so its customers never need the country prefix.
 */
export const formatCurrency = (
    amount: number,
    currencyCode: string,
    { minimumFractionDigits, maximumFractionDigits = 2 }: { minimumFractionDigits?: number; maximumFractionDigits?: number } = {},
): string => new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: currencyCode.toUpperCase(),
    currencyDisplay: 'narrowSymbol',
    minimumFractionDigits,
    maximumFractionDigits,
}).format(amount)

/** The plain symbol for a currency code ("$" for USD, CAD and AUD), or the code if unknown. */
export const currencySymbol = (currencyCode: string): string => {
    try {
        return formatCurrency(0, currencyCode).replace(/[\d.,\s]/g, '') || currencyCode
    } catch {
        return currencyCode
    }
}

export const formatPriceWithSymbol = (symbol: string, amount: number): string => {
    return `${symbol}${formatPriceNumber(amount)}`
}
